import React, { useContext } from 'react';

import { ConfigContext } from '../ConfigProvider';
import { OrderDetailsForm } from './OrderDetailsForm';
import { OrderDetailsReceipt } from './OrderDetailsReceipt';
import { OrderDetailsBoxes } from './OrderDetailsBoxes/OrderDetailsBoxes';


const ORDER_DETAILS_TYPE_RECEIPT = 'receipt';
const ORDER_DETAILS_TYPE_TRIAL = 'trial';
// const ORDER_DETAILS_TYPE_CHECKOUT = 'checkout';


export function OrderDetails(props) {
    const {
        orderDetailsType,
        pageId,
    } = useContext(ConfigContext);
    const currentOrderDetailsType = props?.orderDetailsType || orderDetailsType;

    if (currentOrderDetailsType === ORDER_DETAILS_TYPE_RECEIPT) {
        return (
            <OrderDetailsReceipt
                {...props}
                pageId={pageId}
            />
        );
    }

    if (currentOrderDetailsType === ORDER_DETAILS_TYPE_TRIAL) {
        return (
            <OrderDetailsBoxes
                {...props}
                pageId={pageId}
            />
        );
    }

    return (
        <OrderDetailsForm
            {...props}
        />
    );
}
